<template>
  <!-- <div v-if="!collezioni"></div> -->
  <div>
    <div v-if="header_page_collezioni" :style="{ 'background-image':'url('+ header_page_collezioni.val('image').link() + ')' }" class="collections-hero">
      <h2 v-if="header_page_collezioni" v-html="header_page_collezioni.val('titolo')" class="text-center"></h2>
    </div>
    <div
    class="d-flex justify-content-center align-items-start box-dual-ring"
    v-if="initial_loading"
    >
      <div class="lds-dual-ring"></div>
    </div>
    <div v-else class="container">
      <div class="breadcrumb py-3">
        <a href="/"> {{ 'Home' }} </a>
        <span> {{ ' / ' }} </span>
        <p> {{ 'Collezioni' }} </p>
      </div>
      <div class="pt-3 text-center lh-lg">
        <p v-if="header_page_collezioni" v-html="header_page_collezioni.val('descrizione_introduttiva')"></p>
      </div>
      <template v-for="c in collezioni" :key="c.id">
        <div class="collection-card-box col-12 d-flex flex-lg-row flex-column mb-5 mt-5" v-if="c.id === 7502644 || c.id === 7503895 || c.id === 7503897">
          <div class="col-lg-6 col-12">
            <img v-if="(c.val('image'))" class="img-fluid" :src="c.val('image').link({'x':600,'y':600,'ext':'jpg'})" :alt="c.val('nome')">
            <img v-else class="img-fluid" src="/collezioni/placeholder.png">
            </div>
          <div class="collection-content col-lg-6 col-12 p-4">
            <div class="collection-title"><h2 class="fw-lighter lh-1">{{ c.val("nome") }}</h2></div>
            <div class="collection-sub"><p>Collection</p></div>
            <div class="collection-desc mb-3"><p>{{ c.val("descrizione") }}</p></div>
            <div @click="goToPage('products/'+clearParams(c.val('nome')))" class="anchor-img mt-4 d-flex">
              {{ trans[schema.lang]['pulsante'] }} <img class="ms-3" src="/icone/freccia_prodotti.svg" alt="freccia">
            </div>
          </div>
        </div>
      </template>

      <div class="divider mb-5"></div>

      <div class="col-12 d-flex flex-md-row flex-column justify-content-around pb-5">
        <template v-for="h in collezioni" :key="h.id">
            <div v-if="h.id === 7503902 || h.id === 7503903" class="col-12 col-md-5 d-flex mt-5 flex-column align-items-center">
                <h2 class="collection-horizontal-title text-center">{{ h.val("nome") }}</h2>
                <img v-if="(h.val('image'))" class="img-fluid img-horizontal jar-pet" :src="h.val('image').link({'x':500,'y':500,'ext':'webp'})" alt="immagine">
                <img v-else class="img-fluid img-horizontal" src="/collezioni/placeholder.png" alt="immagine">

                <div class="anchor-img mt-5" @click="goToPage('products/' +  clearParams(h.val('nome')))">
                  {{ trans[schema.lang]['scopri'] }} <img class="ms-3" src="/icone/freccia_prodotti.svg" alt="freccia">
                </div>
            </div>
        </template>
      </div>
      <div class="col-12 d-flex justify-content-center">
        <div class="col-12 col-md-5 d-flex mt-5 flex-column align-items-center">
          <h2 class="collection-horizontal-title text-center">{{ trans[schema.lang]['accessori'] }}</h2>
          <img v-if="anteprima_accessori && anteprima_accessori.length>0 && anteprima_accessori[0].val('immagine_accessori')" class="img-fluid img-horizontal" :src="anteprima_accessori[0].val('immagine_accessori').link({'x':500,'y':500,'ext':'webp'})" alt="immagine">
          <img v-else class="img-fluid img-horizontal" src="/collezioni/placeholder.png" alt="immagine">
          <div class="anchor-img mt-5" @click="goToPage('gamme-accessori')">
            {{ trans[schema.lang]['scopri'] }} <img class="ms-3" src="/icone/freccia_prodotti.svg" alt="freccia">
          </div>
        </div>
      </div>
      <div class="ideas-anchor" @click="goToPage('ispirazioni')" >
        <div style="background-image: url('/collezioni/bt_pag_prodotti.jpg');" class="all-prods mt-5 mb-5 pt-5 pb-5 d-flex flex-xl-row flex-column justift-content-between align-items-center">
          <div class="all-prods-left col-10 p-2 p-xl-5 d-flex flex-column justify-content-center">
            <h4>{{ trans[schema.lang]['idee_chiare'] }}</h4>
            <p>{{ trans[schema.lang]['idee_chiare_testo'] }}</p>
          </div>
          <div class="col-6 col-md-3 col-xl-2 p-5 d-flex align-items-center">
            <img class="img-fluid" src="/icone/freccia_prodotti.svg" alt="freccia">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { defineComponent } from "@vue/runtime-core";
import { Schema } from "onpage-js";

export default defineComponent({
  props: {
    schema: {
      type: Schema,
      required: true,
    },
    pagine_web: {
      required: true,
    }
  },
  mounted() {
    window.document.getElementById('app').scrollIntoView()
  },
  data() {
    return {
      collezioni: null,
      anteprima_accessori: null,
      header_page_collezioni: null,
      cerca: "",
      correct_img: null,
      initial_loading: false,
      trans: {
        'it': {
          scopri: "SCOPRI DI PIÙ",
          pulsante: "SCOPRI LA COLLEZIONE",
          accessori: "Tutti gli accessori",
          idee_chiare: "Hai le idee chiare?",
          idee_chiare_testo: "Guarda l'intera gamma prodotti e scegli in base alle tue esigenze",
        },
        'en': {
          scopri: "FIND OUT MORE",
          pulsante: "DISCOVER THE COLLECTION",
          accessori: "All accessories",
          idee_chiare: "Do you have clear ideas?",
          idee_chiare_testo: "See the entire product range and choose according to your needs",
        }
      }
    };
  },
  async created() {
    this.initial_loading = true;
    if(this.initial_loading){
      this.refreshCollezioni().then(()=>{
        this.initial_loading = false;
      })
    } else {
      this.initial_loading = true;
    }
    // this.updateLanguage();
  },
  computed: {
    collezioni_query(){
      const schema = this.schema;
      if (!schema) return;
      const q = schema.query("collezioni");
      return q;
    },
  },
  methods: {
    goToPage(path) {
      this.$router.push({ path: `/${path}` })
    },
    async refreshCollezioni() {
      this.collezioni = await this.collezioni_query.all();
    },
    getPreviewAccessori(){
      this.anteprima_accessori = this.pagine_web.filter(x => x.id == "17450257");
    },
    getHeaderCollezioni(){
      this.header_page_collezioni = this.anteprima_accessori
      this.header_page_collezioni = this.header_page_collezioni[0].relSync('header')[0]
    },
    clearParams(nome){
      return nome.replaceAll("/","-").replaceAll(" ","_");
    },

  },
  watch: {
    pagine_web(){
      if(this.pagine_web){
        this.getPreviewAccessori();
        this.getHeaderCollezioni();
      }
    }
  }
});
</script>


<style>
*{
  margin: 0;
  padding: 0;
  font-family: 'Poppins', sans-serif;
}
.container{
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.collections-hero{
  width: 100%;
  height: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.collections-hero h2{
  font-size: 42px;
  font-weight: 300;
  color: #fff;
  mix-blend-mode: difference;
}
.collections-hero h2 span{
  font-weight: 200;
  text-transform: uppercase;
}
.collection-card{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items:center;
  margin: 0 auto;
}
.collection-title h2{
  font-size: 112px !important;
  color: #646363;
}
.collection-sub{
  font-size: 32px;
  font-weight: 100;
}
.collection-desc{
  font-size: 1rem;
  color: #646363;
}
.collection-card-box:nth-child(odd){
  flex-direction: row-reverse !important;
}
.collection-content{
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.ideas-anchor, .anchor-img{
  color: #000;
  text-decoration: none;
}
.anchor-img{
  font-size: 1.2rem;
}
.ideas-anchor:hover{
  color: #000;
}
.anchor-img:hover{
  color: #000;
  transform: translate(10px);
  transition: all 200ms ease-in-out;
}
.divider{
  padding-bottom: 20px;
  border-bottom: 1px solid #000;
}
.collection-horizontal-title{
  font-size: 42px;
}
.collection-horizontal-par{
  font-size: 32px;
}
.all-prods a{
  width: 100%;
}
.anchor-img img{
  width: 50px;
}
.all-prods-left h4, .all-prods-left p{
  font-size: 32px;
  font-weight: 600;
}
.all-prods-left p{
  font-weight: 300;
  margin-bottom: 0;
}
.all-prods{
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.lds-dual-ring{
  margin-top: 100px;
}
.breadcrumb{
  font-size: 14px !important;
  color: #646363;
}
.breadcrumb a{
  color: #646363;
}
.breadcrumb a:hover{
  color: #000;
}
.jar-pet{
  border: 1px solid #d1d1d1;
}

@media (max-width: 1024px){
  .collections-hero{
    height: 400px;
  }
}
@media (max-width: 991px){
  .collection-card-box:nth-child(odd){
  flex-direction: column !important;
}
}
</style>
